import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(legal)/privacy-policy")({
  component: PrivacyPolicy,
});

function PrivacyPolicy() {
  return (
    <div className="px-4 py-10 flex justify-center">
      <div className="w-full max-w-2xl">
        <Button
          onClick={() => window.history.back()}
          variant="outline"
          className="mb-4"
        >
          ← Go Back
        </Button>
        <Card>
          <CardContent className="p-6 space-y-6">
            <h1 className="text-3xl font-semibold">Privacy Policy</h1>

            <p>
              Crayons Code ("we", "our", "us") respects your privacy and is
              committed to protecting your personal information. This Privacy
              Policy explains how we collect, use, and safeguard your data when
              you use our application.
            </p>

            <h2 className="text-xl font-semibold">1. Information We Collect</h2>
            <p>
              We collect only the information necessary to provide and improve
              our services. This may include:
            </p>
            <ul className="list-disc list-inside text-sm space-y-1 text-muted-foreground">
              <li>
                Personal identification information (e.g., name, email address)
              </li>
              <li>
                Usage data and analytics to understand service performance
              </li>
              <li>
                Cookies and tracking technologies to personalize your experience
              </li>
            </ul>

            <h2 className="text-xl font-semibold">
              2. How We Use Your Information
            </h2>
            <p>Your information is used solely to:</p>
            <ul className="list-disc list-inside text-sm space-y-1 text-muted-foreground">
              <li>Provide, maintain, and improve our services</li>
              <li>Communicate with you regarding updates or support</li>
              <li>Ensure security and prevent fraud</li>
            </ul>

            <h2 className="text-xl font-semibold">
              3. Data Sharing and Disclosure
            </h2>
            <p>
              We do not sell, trade, or rent your personal information to third
              parties. We may share information with trusted service providers
              only to support service delivery and subject to confidentiality
              agreements.
            </p>

            <h2 className="text-xl font-semibold">4. Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your
              data against unauthorized access, alteration, disclosure, or
              destruction.
            </p>

            <h2 className="text-xl font-semibold">5. Your Rights</h2>
            <p>
              You have the right to access, correct, or delete your personal
              data. You can also opt out of marketing communications by
              contacting us.
            </p>

            <h2 className="text-xl font-semibold">6. Cookies</h2>
            <p>
              Our application uses cookies to enhance your experience. You can
              control cookie preferences through your browser settings.
            </p>

            <h2 className="text-xl font-semibold">7. Children's Privacy</h2>
            <p>
              Our services are not directed to individuals under the age of 13,
              and we do not knowingly collect personal data from children.
            </p>

            <h2 className="text-xl font-semibold">8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy occasionally. We encourage you
              to review this page periodically for any changes.
            </p>

            <p className="text-sm text-muted-foreground">
              For questions or concerns, please contact us at
              privacy@crayonscode.com.
            </p>

            <div className="text-center text-sm text-muted-foreground mt-8">
              Last updated: July 13, 2025
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
